module.exports = __webpack_public_path__ + "static/media/jc1.44414adc.jpg";